<template>
  <v-menu location="bottom end">
    <template #activator="{ props: menuProps }">
      <v-btn
        variant="flat"
        class="btn-refresh home-wage-admin-menu-btn"
        size="small"
        v-bind="menuProps"
      >
        <v-icon size="14">mdi-text-box-outline</v-icon>
        사원 멘트
        <v-icon size="14">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact" class="wage-report-menu-list home-wage-admin-menu-list">
      <v-list-item :disabled="!hasSelectedEmployee" @click="emit('open-employee-condition')">
        <v-list-item-title>산출 근거 · 적용 조건</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    hasSelectedEmployee?: boolean;
  }>(),
  {
    hasSelectedEmployee: false,
  }
);

const emit = defineEmits<{
  'open-employee-condition': [];
}>();
</script>
